import { render } from "./BlogInOnLaysLongevity.vue?vue&type=template&id=cf235ffc"
import script from "./BlogInOnLaysLongevity.vue?vue&type=script&lang=js"
export * from "./BlogInOnLaysLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__